import Utility from "../utility/Utility";
import HttpService from "./HttpService";


const httpService = HttpService.instance;
const keycloakURL = Utility.env?.REACT_APP_PCPO_BACK_END_HEALTH_API + '/token';
const cdrUrl = Utility.env?.REACT_APP_PCPO_BACK_END_HEALTH_API + '/cdr';
const pcpoUrl = Utility.env.REACT_APP_PCPO_BACK_END_HEALTH_API + '/pcpo';
const pcpUrl = Utility.env?.REACT_APP_PCPO_BACK_END_HEALTH_API + "/pcp";


export const keycloakCall = async () => {
    const method = 'POST';
    const results = await httpService.callPcpoKeycloakAPI(keycloakURL, method);
    const keycloak = results;

    if (keycloak.status === 200) {
        return "Success"
    } else {
        return "Fail"
    }
};

export const cdrAccess = async () => {
    try {
        const results = await httpService.callPcpoCdr(cdrUrl);
        return "Success"
    }
    catch (error) {
        return "Fail"
    }
};

export const pcpCall = async () => {
    const method = 'GET';
    const results = await httpService.callBackEndApi(pcpUrl, method);
    
    if (results.status === 200) {
        return "Success";
    } else {
        return "Fail";
    }
};


export const pcpoCall = async () => {
    const method = 'GET';
    const results = await httpService.callBackEndApi(pcpoUrl, method);

    if (results.status === 200) {
        return "Success";
    } else {
        return "Fail";
    }
};

export const mapCheckIdIoAPI = async (id: string) => {
    let finalURL = ""
    let finalStatus = ""
    switch (id.toLowerCase()) {
        case "keycloak":
            const resp = await keycloakCall()
            finalURL = Utility.env?.REACT_APP_KEYCLOAK_URL + '/realms/h/protocol/openid-connect/token'
            finalStatus = resp
            break;
        case "cdr":
            const cdrResponse = await cdrAccess()
            finalURL = Utility.env?.REACT_APP_API_BASE_URL + '/fhir/EODB/Patient'
            finalStatus = cdrResponse
            break;
        case "pcpo":
            finalURL = pcpoUrl
            finalStatus = await pcpoCall()
            break;
        case "pcp":
            finalURL = pcpUrl
            finalStatus = await pcpCall()
            break;
        default:
            console.log("Do Nothing");
    }

    return {
        url: finalURL,
        status: finalStatus
    }
}
